import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import AddWasteCategoryOffCanvas from "./AddWasteCategoryOffCanvas";
import WasteCategoryExcerpt from "./WasteCategoryExcerpt";
import EditWasteCategoryOffCanvas from "./EditWasteCategoryOffCanvas";
import { useGetWasteCategoryQuery } from "./categorySlice";
import SpinnerForPage from "../../../components/spinner/SpinnerForPage";

const WasteCategoryList = () => {

    const refOpen = useRef(null)
    const {
        data: category,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetWasteCategoryQuery('getWasteCategory')
    const [status, setStatus] = useState("");
    const [stateEditWasteCategory, setStateEditWasteCategory] = useState()

    const handleReset = () => window.location.reload();

    const editWasteCategory = (wc_id) => {
        console.log(wc_id);
        const wcData = category?.entities[wc_id];
        refOpen.current.click()
        setStateEditWasteCategory({ wc_name: wcData.wc_name, wc_id: wc_id, wc_active: wcData.wc_active })
        console.log({ wc_name: wcData.wc_name, wc_id: wc_id, wc_active: wcData.wc_active });


    }


    return (
        <>
            {isLoading && <SpinnerForPage />}

            {/* {!isError &&  */}
            <div className="container-fluid mt-5">
                <div className="Card_table_data w-25">
                    <button type="button" className="Add_button bg-left-navabr w-100 text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffsearch" aria-controls="depOffsearch"> Search</button>

                    <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffsearch" aria-labelledby="depOffsearch">
                        <div className="offcanvas-header">
                            <h5 className="offcanvas-title" id="offcanvas1Label">Search</h5>
                            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ></button>
                        </div>
                        <select className="form-select" value={status} onChange={(e) => setStatus(e.target.value)}>
                            <option value="">Select Status</option>
                            <option value="0">Active</option>
                            <option value="1">Inactive</option>
                        </select>
                        <button className="bg-left-navabr mt-2 text-light  btn btn-secondary" data-bs-dismiss="offcanvas" aria-label="Close" >Data Search</button>
                        <button type="reset" className="bg-left-navabr  text-light  btn btn-secondary mt-2" onClick={handleReset} data-bs-dismiss="offcanvas" aria-label="Close">
                            Reset
                        </button>
                    </div>
                </div>
                <form className="mobile-hidden">
                    <div className="row mt-4">
                        <div style={{ height: "40px" }} className="col-md-12  d-flex justify-content-center gap-2">
                            <select className="form-select w-25 " value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option value="">Select Status</option>
                                <option value="0">Active</option>
                                <option value="1">Inactive</option>
                            </select>

                            <button type="button" className="bg-left-navabr  text-light  btn btn-secondary" >
                                Search
                            </button>
                            <button type="reset" className="bg-left-navabr  text-light  btn btn-secondary" onClick={handleReset}>
                                Reset
                            </button>

                            <div className="text-right ">
                                <AddWasteCategoryOffCanvas />
                            </div>
                        </div>

                    </div>
                </form>
                <div className="card card-dark mt-4">
                    {

                        (
                            <div className="table-border-style">
                                <div className="table-responsive sidebarhome ">
                                    <table className="table table-striped">
                                        <thead className="mobile-hidden">
                                            <tr className="text-center">
                                                <th scope="col">Sr. No.</th>
                                                <th scope="col">Category Name</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Create Date</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                category?.ids?.map((id, index) => {
                                                    return (
                                                        <WasteCategoryExcerpt key={index} editWasteCategory={editWasteCategory} id={id} index={index} />
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            {/*  } */}
            {/* {isError && <div>Something went wrong</div>} */}
            <EditWasteCategoryOffCanvas refOpen={refOpen} setStateEditWasteCategory={setStateEditWasteCategory} stateEditWasteCategory={stateEditWasteCategory} />


        </>
    )
}

export default WasteCategoryList;

